
import React, { useEffect, useState } from 'react'
import { useApp } from '../../helpers/appContext'
import { Section, Button, general, PaddedContent, withAlertMessages, icons} from 'daymap-library'
import { useAuth } from '../../helpers/authContext';
import Student from '../../components/Student/Student'
import Event from '../../components/Calendars/Event'
import {useNavigate, useParams } from 'react-router-dom';
import Alert, { ALERT_TYPE } from  '../../components/Alert/Alert';

function  EventSignIn(){
    const { student, mode } = useApp();
    const  [event, setEvent]  = useState(null);
    const { lmsFetch } = useAuth();
    const [signInComplete, setSignInComplete] = useState(false);
    const navigate = useNavigate();
    const { calendarId } = useParams();

    const getlatestEventForCalendar = async () => {
        const [eventInfo] = lmsFetch(`/lms/api/checkin/EventForCalendarAndStudent?calendarID=${calendarId}&studentID=${student.ID}`);
        const response = await eventInfo();
        setEvent(response.data);
      }
    
      useEffect(() => {
        if(!student){ navigate(".."); return; }  
        if(event === null)
          getlatestEventForCalendar();       
      });

      const onSignIn = async() => {
        const [markEvent] = lmsFetch(`/lms/api/checkin/MarkStudentForScheduledEvent?eventID=${event.EventID}&studentID=${student.ID}`, null, {returns: 'text'});
        const response = await markEvent();

        if(response.data == ""){
          setSignInComplete(true);
        }else{
          this.props.alertMessage.error(
            response.data,
            "Error saving sign in: "
          );
        }
      }
      
      if(signInComplete){
        return <SignInComplete headingText='Sign In'></SignInComplete>
      }
    return (
      <Section>
        <Student {...student} />
        <PaddedContent>
          {event? <Event {...event}></Event> : <NoEventFound></NoEventFound>}
          <div>
        {
          (event && student)? <div><Button iconClass={icons.ICON_CSS_CLASS.Back} text="Cancel" onClick={() => navigate(`/events/${calendarId}`)} large secondary /><Button id="btnSignInEvent" iconClass={icons.ICON_CSS_CLASS.Play} text="Sign In" onClick={onSignIn} large></Button></div> : <Button iconClass={icons.ICON_CSS_CLASS.Back} text="Cancel" onClick={() => navigate(`/events/${calendarId}`)} large secondary />
        }
        </div>
        
        </PaddedContent>
      </Section>

    )
}

const SignInComplete = ({headingText}) => {
  const { settings } = useAuth();
  const navigate = useNavigate();
  const { calendarId } = useParams();
  const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => navigate(`/events/${calendarId}`) });

  if(!(settings.KioskRedirectDelay > 0))
  {
      navigate(`/events/${calendarId}`);
      return "";
  }

  return <Alert type={ALERT_TYPE.Success} heading={headingText + " Complete"}>
          Returning to student select in {secondsTilRedirect} seconds.
      </Alert>
}

const NoEventFound = () => {
  const { mode } = useApp();
  return (
    <div>
      <br></br>
      <div>No {mode} events were found for you at this time.</div>
      <br></br>
      <div>Reasons may include:</div>
      <ul>
        <li>You are not scheduled for a {mode} event at this time.</li>
        <li>You have already signed into the current session.</li>
      </ul>
      If you believe this is incorrect, please see a staff member for assistance.
    </div>
    
  )
}

export default withAlertMessages(EventSignIn);